const routes = {
  notFound: '/404',
  listParticipants: '/participantes/:fromWhere/:processId',
  notAllowed: '/noAutorizado',
  manageParticipants: '/participantes/agregar/:fromWhere/:processId',
  root: '/'
}

export default routes
